import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.344 3.806 12 3.735l2.656.071a2.94 2.94 0 0 1 2.332 1.391l.821 1.316a1.56 1.56 0 0 0 1.11.71l1.152.178c1.432.239 2.429 1.493 2.429 2.909v8.426a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V10.31c0-1.416.997-2.67 2.429-2.909l1.152-.178a1.56 1.56 0 0 0 1.11-.71l.821-1.316a2.94 2.94 0 0 1 2.332-1.391M12 5.235l-2.575.069c-.46.025-.886.28-1.14.687l-.821 1.316a3.06 3.06 0 0 1-2.172 1.401l-1.116.172C3.501 8.992 3 9.591 3 10.309v8.426a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-8.426c0-.719-.501-1.317-1.175-1.429l-1.116-.172a3.06 3.06 0 0 1-2.172-1.401l-.821-1.316a1.44 1.44 0 0 0-1.14-.687zm0 4.5a3.75 3.75 0 0 0 0 7.5 3.75 3.75 0 0 0 0-7.5m-5.25 3.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 1 1-10.5 0M18 11.235a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75z"
}));
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;